import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';
import { useSignup } from '../../../contexts/SignupContext';

const SignupBusinessDocuments = () => {
  const navigate = useNavigate();
  const { updateSignupState } = useSignup();
  const [selfie, setSelfie] = useState(null);
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!selfie || !document) {
      toast.error('Please upload both selfie and business document');
      return;
    }

    setLoading(true);

    updateSignupState({
      businessDocuments: {
        selfie: selfie.name,
        document: document.name,
      },
    });

    toast.success('Documents uploaded successfully');
    navigate('/signup/success');
    setLoading(false);
  };

  return (
    <AuthLayout
      title="Upload business documents"
      subtitle="Upload a selfie and your business proof"
      onBack={() => navigate(-1)}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Selfie</label>
          <input
            type="file"
            accept="image/*"
            className="form-input"
            onChange={(event) => setSelfie(event.target.files?.[0] || null)}
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Business Proof</label>
          <input
            type="file"
            className="form-input"
            onChange={(event) => setDocument(event.target.files?.[0] || null)}
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Uploading...' : 'Submit Registration'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupBusinessDocuments;


